import { Badge, MultipleBadge, SingleBadge } from "@warp/types/product"

export function isSingleBadge(badge: Badge): badge is SingleBadge {
  return "value" in badge
}

export function isMultipleBadge(badge: Badge): badge is MultipleBadge {
  return "values" in badge
}
